import $ from "jquery";

import {
  bindSearchDropdowns,
} from '../helper_modules/select2_form_helpers';

const searchFormElements = {
  dropdowns: $(`.search-box-field`),
};

export default class ShipmentSearchService {
  constructor() {
    this.searchFormElements = searchFormElements;
    this.bindElements();
  }

  static init() {
    if ($(`.shipments.index`).length === 0) {
      return;
    }

    return new ShipmentSearchService();
  }

  bindElements() {
    bindSearchDropdowns(this.searchFormElements);
  }
}
